/** Copy of the salesInvoices page (Operations), ported from VentaHub. */
export const salesInvoices = {
  title: 'Sales invoices',
  description: 'Invoices raised to retailers, with what has been received.',
  empty: 'No sales invoices to show',
  emptyHint: 'Nothing matches these filters.',
  filters: {
    warehouse: 'Warehouse',
    party: 'Retailer',
    text: 'Invoice number',
    dates: 'Invoice date',
    void: 'Include voided',
  },
  columns: {
    number: 'Invoice number',
    date: 'Invoice date',
    warehouse: 'Warehouse',
    party: 'Retailer',
    poId: 'PO',
    units: 'Units',
    amountWoTax: 'Excl. tax',
    amount: 'Amount',
    received: 'Received',
    cndnValue: 'Credit/debit notes',
    creditPeriod: 'Credit days',
    dispatchDate: 'Dispatched',
    deliveryDate: 'Delivered',
    trackingNumber: 'Tracking',
    valid: 'Status',
  },
  open: 'Open {{code}}',
  lines: {
    title: 'Lines',
    description: 'What is on this document.',
    empty: 'No lines on this document.',
    columns: {
      skuCode: 'SKU',
      skuName: 'Name',
      boxCode: 'Box',
      quantity: 'Quantity',
      price: 'Price',
      cost: 'Cost',
      vatRate: 'VAT %',
      expiryDate: 'Expiry',
    },
  },
  actions: {
    new: 'New invoice',
    preview: 'Preview lines',
    raise: 'Raise invoice',
    dispatch: 'Dispatch',
    deliver: 'Deliver',
    edit: 'Edit',
    boxes: 'Boxes',
    packing: 'Packing list',
    download: 'Download invoice',
    delete: 'Delete',
    movements: 'Dispatch / deliver from sheet',
  },
  form: {
    hint: '1. Fill in who and what, and list the boxes to bill. 2. Preview the lines and check each price. 3. Check, then raise the invoice.',
    scope: 'Warehouse · Retailer',
    chooseWarehouseAndRetailerFirst: 'Choose a warehouse and a retailer first.',
    needHeader:
      'Choose a warehouse and retailer, and fill in the invoice number, date, a 3-letter currency and at least one box.',
    previewFirst: 'Preview the lines before checking or raising the invoice.',
    needPrice: '{{code}} has no retailer price. Type a price for it.',
    badPrice: 'The price or VAT for {{code}} is not a number.',
    badCredit: 'Credit days must be a whole number.',
    chooseWarehouse: 'Choose a warehouse.',
    chooseRetailer: 'Choose a retailer.',
    needNumber: 'Type the invoice number.',
    needDate: 'Choose the invoice date.',
    badCurrency: 'Type a 3-letter currency code.',
    needBoxes: 'List at least one box.',
    badVat: 'The VAT for {{code}} must be a percentage from 0 to 100, to two decimals.',
    currency: 'Currency',
    po: 'Retailer PO',
    choosePo: 'Choose a purchase order',
    comment: 'Comment',
    boxes: 'Box codes (one per line)',
    nothing: 'These boxes hold nothing to bill.',
    price: 'Price per unit',
    vat: 'VAT %',
    noRetailerPrice: 'No retailer price — type one',
    priceFor: 'Price for {{code}}',
    vatFor: 'VAT % for {{code}}',
    noProblems: 'No problems found. The invoice is ready to raise.',
    downloadProblems: 'Download problems',
    saved: 'Invoice {{code}} raised.',
    choose: 'Choose a retailer',
    downloadTemplate: 'Download template',
    downloadBoxCodes: 'Download box codes',
    uploadBoxes: 'Upload details from file',
    downloadPriceTemplate: 'Download template',
    uploadPrices: 'Upload prices from file',
    cannotReadFile: 'Could not read the file.',
    noFileRows: 'No rows found in the file.',
    noMatchingSkus: 'No matching SKUs found in the file.',
    loadedBoxes_one: 'Loaded {{count}} box code from file.',
    loadedBoxes_other: 'Loaded {{count}} box codes from file.',
    loadedPrices_one: 'Loaded a price for {{count}} SKU from the file.',
    loadedPrices_other: 'Loaded prices for {{count}} SKUs from the file.',
  },
  move: {
    dispatchTitle: 'Dispatch {{code}}',
    deliverTitle: 'Deliver {{code}}',
    dispatchHint: 'The invoice must be reviewed before it can be dispatched.',
    deliverHint: 'The delivery date cannot be before the dispatch date.',
    date: 'Date',
    dispatched: 'Invoice {{code}} dispatched.',
    delivered: 'Invoice {{code}} delivered.',
  },
  edit: {
    title: 'Edit {{code}}',
    hint: 'Change the header or any line price. Totals are worked out again when you save.',
    clearMovement: 'Clear the dispatch and delivery dates',
    saved: 'Invoice {{code}} saved.',
    downloadTemplate: 'Download template',
    uploadCosts: 'Upload costs from file',
    loadedCosts_one: 'Loaded a cost for {{count}} line from the file.',
    loadedCosts_other: 'Loaded costs for {{count}} lines from the file.',
  },
  boxes: {
    title: 'Boxes on {{code}}',
    hint: 'Take a box off, or add another box from this warehouse.',
    dispatchedHint: 'This invoice has been dispatched, so its boxes cannot change.',
    remove: 'Remove',
    removeOne: 'Remove box {{code}}',
    add: 'Box to add',
    addButton: 'Add box',
    done: 'Done',
  },
  packing: {
    title: 'Packing list for {{code}}',
    hint: 'Every SKU in each box, with the retailer’s own SKU code.',
    retailerSku: 'Retailer SKU',
    download: 'Download packing list',
  },
  delete: {
    title: 'Delete {{code}}?',
    description: 'Only an invoice with no boxes left on it can be deleted. Remove its boxes first.',
    done: 'Invoice {{code}} deleted.',
  },
  movements: {
    title: 'Dispatch and deliver from a sheet',
    hint: 'Set dispatch and delivery dates for many invoices in one warehouse at once. The sheet goes for approval, and the invoices change once it is accepted.',
    warehouseStep: 'Warehouse',
    warehouseHint: 'Every invoice on the sheet is one of this warehouse’s.',
  },
} as const
